import { getAsyncState } from '../selectors';
export var getZoneInfoState = getAsyncState('zoneInfo');
export var getTariffsState = function (state) { var _a; return (_a = getZoneInfoState(state).data) === null || _a === void 0 ? void 0 : _a.max_tariffs; };
export var getTariffByClass = function (tariff, state) {
    var _a;
    if (tariff === void 0) { tariff = ''; }
    return ((_a = getTariffsState(state)) === null || _a === void 0 ? void 0 : _a.find(function (t) { return t.class === tariff; }));
};
